import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {DATE_FORMAT} from '../../helpers/DateHelper';

export default class DatePickerCustom extends React.Component{
    constructor(props) {
        super(props);
    }

    onChange(moment) {
        this.props.formInput.onChange(moment.unix());
    }

    componentDidMount() {
        this.validateMinValue(this.props.selected, this.props.minDate);
    }

    componentWillReceiveProps(nextProps) {
        this.validateMinValue(nextProps.selected, nextProps.minDate);
    }

    validateMinValue(actualDate, minDate) {
        if(!minDate) {
            return;
        }

        if(!actualDate || (minDate.unix() > actualDate.unix())) {
            this.onChange(minDate);
        }
    }

    render() {
        let {
            className='form-control col-sm-12',
            minDate = moment(),
            dateFormat = DATE_FORMAT,
            selected,
        } = this.props;

        return <DatePicker
            className={className}
            dateFormat={dateFormat}
            locale={moment.locale()}
            minDate={minDate}
            selected={selected}
            disabledKeyboardNavigation={true}
            onChange={this.onChange.bind(this)}
        />;
    }
};


// WEBPACK FOOTER //
// ./web/src/components/common/form/DatePickerCustom.jsx